import React from "react"
import styled from 'styled-components'
import { breakpoints, colors, mixins, sizes } from '../css-variables'
import CategoryList from '../atoms/CategoryList'
import { Link } from "gatsby"
import arrowSVG from '../../svg/Arrow_45-degrees_white_1x.svg'
import parse from "html-react-parser"


const ContentCard = ({ className, title, link, keyTakeaways, categories, taxContentTypes, archiveCard, algolia, linkDestination, date, modified }) => {
  //console.log(title)
  const { summary } = (typeof keyTakeaways !== 'undefined' && keyTakeaways) || {}

    const titleLink = linkDestination?.isLinkOnly ? 
      linkDestination?.linkDestination ? (<a className="externalLink" href={linkDestination.linkDestination} target="_blank" rel="noreferrer">{title}</a>) : null
      : (<Link to={link}>{title}</Link>)

      const newDate = new Date();
      let twoWeeksAgo = newDate - 1000 * 60 * 60 * 24 * 14
      let oneMonthAgo = newDate - 1000 * 60 * 60 * 24 * 30
      const isNewModified = new Date(date).getTime() > new Date(twoWeeksAgo).getTime() ? 'New' : new Date(modified).getTime() > new Date(oneMonthAgo).getTime() ? 'Updated' : null

    return (
    <div className={`${className} nomargin`}>
      <div className="card-inner-wrap">
        {taxContentTypes?.nodes?.[0]?.name && (
          <div className='contentType'>{taxContentTypes.nodes[0].name}{isNewModified && (<span>{isNewModified}</span>)}</div>
        )}
        {titleLink}
        {categories && (
          <CategoryList className="category-list" categories={categories} />
        )}
        {archiveCard && summary && !algolia && (
          <div className="summary">{parse(summary)}</div>//this has to be parse, otherwise the summaries disappear everywhere in prod?
        )}
        {archiveCard && summary && algolia && (
          <div className="summary" dangerouslySetInnerHTML={{__html: summary}} />
        )}
      </div>
    </div>)
}

const StyledContentCard = styled(ContentCard)`
  background-color: ${props => props.archiveCard ? 'transparent' : `${colors.bgGrey}` };
  margin-bottom: ${props => props.archiveCard ? '36px' : '24px'};
  padding: ${props => props.archiveCard ? '0 0 36px' : '24px 0'};
  width: 100%;
  @media screen and ${breakpoints.tabletS} {
    ${mixins.fixed_width_element}
    padding: ${props => props.archiveCard ? '0 0 36px' : '24px 18px'};
  }



  > div {
    ${mixins.fixed_width_element}
    ${props => props.algolia ? '' : `${mixins.fixed_width_content_pad}` }
    
    margin-right: 0 !important; // need this because of a dumb 'inherit' choice elsewhere
  }
  border-bottom: ${props => props.archiveCard ? `1px solid ${colors.rulesGrey}` : 'transparent'};
  .contentType{
    ${mixins.card_label}
    margin-bottom: 8px;
    span{
      color:${colors.mainRed};
      padding-left: 8px;
      border-left: 2px solid ${colors.textGrey};
      margin-left: 8px;
    }
  }
  a {
    display: block;
  }
  p > a {
    display: inline;
  }
  .externalLink{
    display: block;
    position: relative;
    :after {
      position: absolute;
      mask: url(${arrowSVG}) no-repeat;
      margin-left: 5px;
      margin-top: 9px;
      width: ${sizes.s13};
      height: ${sizes.s13};
      background: ${colors.mainRed};
      content: '';
    }
  }
  .category-list{
    padding: ${props => props.archiveCard ? '18px 0 0' : '12px 0 0'};
    margin-bottom: 0;
  }
  .tag__item{
    font-size: 14px;
    line-height: 24px;
  }
  .summary {
    margin-top: 18px;
    margin-bottom: 0;
    p:last-of-type{
      margin:0;
    }
    
  }
  

 `

 export default StyledContentCard